import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

const BADGE = { active: "bg-emerald-50 text-emerald-700", provisional: "bg-amber-50 text-amber-800", inactive: "bg-slate-100 text-slate-500" };

export function FrTaxCard() {
  const [d, setD] = useState(null);
  const [f, setF] = useState({ active_vat_category: "", effective_from: "", reason: "", approval_phrase: "" });
  const load = () => api.get("/admin/tax/fr").then((r) => { setD(r.data); setF((x) => ({ ...x, active_vat_category: r.data.active_vat_category })); });
  useEffect(() => { load(); }, []);
  const save = async () => {
    try { const r = await api.put("/admin/tax/fr", f); setD(r.data); setF({ ...f, reason: "", approval_phrase: "" }); toast.success("French VAT category updated"); }
    catch (e) { toast.error(formatError(e)); }
  };
  if (!d) return null;
  return (
    <div className="mt-5 rounded-xl ring-1 ring-sky-200 bg-sky-50/40 p-5" data-testid="fr-tax-card">
      <h3 className="font-bold text-[#1B3A6B]">French VAT regime (protected)</h3>
      <p className="text-xs text-slate-600 mt-1">Changes need accountant confirmation, a reason, an effective date and the phrase <b>ACCOUNTANT APPROVED</b>. Existing bookings keep the VAT captured when they were created.</p>
      <ul className="mt-3 space-y-1.5 text-sm">
        {d.vat_categories.map((c) => (
          <li key={c.code} className="flex flex-wrap items-center gap-2" data-testid={`fr-tax-cat-${c.code}`}>
            <code className="text-xs">{c.code}</code><span>{c.name}</span><span className="text-slate-500">· {c.exempt ? "exempt" : `${c.rate}%`}</span>
            <span className={`text-[10px] font-bold uppercase px-2 py-0.5 rounded-full ${BADGE[c.status] || BADGE.inactive}`}>{c.status}</span>
          </li>
        ))}
      </ul>
      <div className="mt-4 grid sm:grid-cols-2 gap-2">
        <Select value={f.active_vat_category} onValueChange={(v) => setF({ ...f, active_vat_category: v })}>
          <SelectTrigger data-testid="fr-tax-select"><SelectValue /></SelectTrigger>
          <SelectContent>{d.vat_categories.map((c) => <SelectItem key={c.code} value={c.code}>{c.code}</SelectItem>)}</SelectContent>
        </Select>
        <Input type="date" value={f.effective_from} onChange={(e) => setF({ ...f, effective_from: e.target.value })} data-testid="fr-tax-date" />
        <Input placeholder="Reason / accountant reference" value={f.reason} onChange={(e) => setF({ ...f, reason: e.target.value })} data-testid="fr-tax-reason" />
        <Input placeholder="Type ACCOUNTANT APPROVED" value={f.approval_phrase} onChange={(e) => setF({ ...f, approval_phrase: e.target.value })} data-testid="fr-tax-phrase" />
      </div>
      <button type="button" onClick={save} className="mt-3 px-4 h-9 rounded-full text-sm font-semibold text-white bg-[#1B3A6B] hover:bg-[#102547]" data-testid="fr-tax-save">Apply VAT category</button>
      {d.log?.length > 0 && (
        <details className="mt-3 text-xs text-slate-600"><summary className="cursor-pointer">Change log ({d.log.length})</summary>
          <ul className="mt-2 space-y-1">{d.log.map((l) => <li key={l.id}>{l.at?.slice(0, 16)} · {l.action} → {l.active_vat_category} · {l.by} · {l.reason}</li>)}</ul>
        </details>
      )}
    </div>
  );
}
